import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'fac_failing_comply_legal_req_not_covered_elsewhere_6'

export const dataPointDefinition = {
  retracedId: 'fac_failing_comply_legal_req_not_covered_elsewhere_6',
  name: 'Is the facility failing to comply with any legal requirements not covered elsewhere regarding Discrimination in Worker T',
  description:
    'Answer No if the facility is complying with all legal requirements not covered elsewhere regarding Discrimination in Worker Treatment.',
  meta: {
    slcpMeta: {
      key: 'wt-dis-40',
      number: 'WT-DIS-29',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-40', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37330,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
